import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on route change (and to hash target if present).
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); return; }
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);
  return null;
}

// Lightweight per-page metadata.
export function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute('content', description);
    }
  }, [title, description]);
  return null;
}

export function SectionHeader({ eyebrow, title, sub, center, className = '' }) {
  return (
    <div className={`${center ? 'text-center mx-auto' : ''} ${className}`} style={center ? { maxWidth: 720 } : { maxWidth: 720 }}>
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <h2 className="section-title">{title}</h2>
      {sub && <p className={`section-sub mt-5 ${center ? 'mx-auto' : ''}`}>{sub}</p>}
    </div>
  );
}

// CTA renders as anchor (external) or button (onClick). Never a router link here.
export function Cta({ children, href, onClick, variant = 'gold', size = 'md', className = '', ...rest }) {
  const sizes = {
    sm: 'h-10 px-5 text-[13.5px]',
    md: 'h-12 px-7 text-[15px]',
    lg: 'h-14 px-9 text-[16px]',
  };
  const base = `inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap ${sizes[size]} ${variant === 'gold' ? 'btn-gold' : 'btn-outline'} ${className}`;
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={base} {...rest}>{children}</a>
    );
  }
  return <button onClick={onClick} className={base} {...rest}>{children}</button>;
}
